// eslint-disable-next-line no-restricted-imports
import { useTranslation as i18nUseTranslation } from 'react-i18next';

export const useTranslation = i18nUseTranslation;
